import { SmartTable } from '../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state, $uibModal, Alert) {
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
    }

    $onInit() {
        this.st = new SmartTable();
    }

    isSelectable(item) {
        return ['CUSTOM', 'APPLICATION'].includes(item.group.type);
    }

    ifSelectable(item) {
        return this.isSelectable(item) && item;
    }

    showRemoveFromGroupsModal() {
        this.$uibModal
            .open({
                component: 'companyUserDirectoriesManageAccountGroupsAppsRemoveFromGroups',
                resolve: {
                    accountId: () => this.accountId,
                    companyId: () => this.companyId,
                    groupIds: () => this.st.selectedItems.map(({group}) => group.id),
                },
            }).result
            .then(() => this.$state.reload(this.$state.current))
            .then(() => this.Alert('success', 'company.user-directories.manage-account.groups-apps.remove-from-groups.removed'))
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/groups-apps/groups-apps.controller.js